import md5 from 'md5'

// suggest we replace this with a more robust UUID generation
// library such as https://github.com/paralleldrive/cuid2
export default function createId() {
  return md5(Date.now().toString())
}
